import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  companyList: [],
  selectedCompany: null
};

const slice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      console.debug(action);
      state.error = action;
    },

    getCompanySuccess(state, action) {
      state.isLoading = false;
      state.selectedCompany = action.payload;
    },

    getCompanyListSuccess(state, action) {
      // console.debug(action.payload);
      state.isLoading = false;
      state.companyList = action.payload;
    },

    createCompanySuccess(state, action) {
      state.isLoading = false;
    },

    clearCompanyDataSuccess(state) {
      state.selectedCompany = initialState.selectedCompany;
    }
  }
});

// Reducer
export default slice.reducer;

// Actions

export function getCompanyList() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const queryString = `query {
          getCompanyList
             {
                name,
                dateCreated,
             }
        }`;

      const response = await axios.post('/graphql', { query: queryString });
      dispatch(
        slice.actions.getCompanyListSuccess(response.data.data.getCompanyList)
      );
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getCompany(brand) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    brand = JSON.stringify(brand);

    try {
      const queryString = `query {
        getCompany(name:${brand})
           {
              name,
              dateCreated,
              lastUpdated,
           }
      }`;

      const response = await axios.post('/graphql', { query: queryString });
      dispatch(slice.actions.getCompanySuccess(response.data.data.getCompany));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export async function createCompany(values) {
  try {
    const queryString = `mutation {
      createCompany(
        name:${JSON.stringify(values.name)}
        )
        {
            name
        }
      }`;

    const response = await axios.post('/graphql', { query: queryString });

    if (response.data.errors && response.data.errors.length > 0)
      throw new Error(response.data.errors[0].message);

    slice.actions.createCompanySuccess(response.data);
  } catch (error) {
    slice.actions.hasError(error);
    throw new Error(error);
  }
}

export function clearCompanyData() {
  return async (dispatch) => {
    dispatch(slice.actions.clearCompanyDataSuccess());
  };
}
export async function updateCompany(values) {
  // return async (dispatch) => {
  // dispatch(slice.actions.startLoading());
  try {
    const queryString = `mutation {
      updateCompany(
            name:${JSON.stringify(values.name)}, 
            dateCreated:${JSON.stringify(values.dateCreated)}
            ) {
                name
            }
        }`;

    const response = await axios.post('/graphql', { query: queryString });
    console.debug(response);
    // dispatch(slice.actions.createBrandSuccess(response.data));
  } catch (error) {
    slice.actions.hasError(error);
  }
}
